import React, { useMemo, useState } from 'react';
import { FormattedMessage, FormattedNumber, useIntl } from 'react-intl';
import { appLocales, TRANSACTION_DESCRIPTIONS } from 'i18n';
import PropTypes from 'prop-types';

import { ReactComponent as Arrow } from 'assets/icons/navigation-arrow.svg';
import Card from 'components/card/Card';
import DateLineItem from 'components/dateLineItem/DateLineItem';
import PlanName from 'components/plan/PlanName';

const TransactionCard = (props) => {
    const [expand, setExpand] = useState(false);

    const { locale } = useIntl();
    const { en, fr } = appLocales;

    const description = useMemo(() => {
        switch (locale) {
            case en:
                return props.description;
            case fr:
                return TRANSACTION_DESCRIPTIONS[props.description] || props.description;
            default:
                return props.description;
        }
    }, [locale]);

    return (
        <Card>
            <div className="card-line-item">
                <div className="transaction-header">
                    <div>
                        <h5 className="transaction-date">
                            <DateLineItem value={props.transactionDate} />
                        </h5>
                        <button onClick={() => setExpand(!expand)}>
                            <Arrow aria-label="expand" className={`arrow-${expand ? 'open' : 'close'}`} />
                        </button>
                    </div>

                    <div>
                        <p className="description-label">{description}</p>
                        <p className="payment-value">
                            <FormattedNumber
                                currency="CAD"
                                currencyDisplay="narrowSymbol"
                                style="currency"
                                value={props.amountPaid}
                            />
                        </p>
                    </div>
                </div>
            </div>
            {expand && (
                <div className="card-line-item">
                    <div className="transaction-item">
                        <p>
                            <FormattedMessage id="transaction.card.plan.label" />
                        </p>
                        <p className="transaction-item-value">
                            <PlanName planId={props.planId} planTitle={props.planName} />
                        </p>
                    </div>
                </div>
            )}
        </Card>
    );
};

TransactionCard.propTypes = {
    amountPaid: PropTypes.number.isRequired,
    description: PropTypes.string.isRequired,
    planId: PropTypes.number.isRequired,
    planName: PropTypes.string.isRequired,
    postDate: PropTypes.string.isRequired,
    transactionDate: PropTypes.string.isRequired,
    transactionType: PropTypes.string.isRequired,
};

export default TransactionCard;
